import { c as _c } from "react/compiler-runtime";
import { getEntitiesByFpIdOnboardings } from '@onefootprint/fetch-dashboard';
import { useInfiniteQuery } from '@tanstack/react-query';
import useEntityId from '@/entity/hooks/use-entity-id';
const useGetOnboardings = () => {
  const $ = _c(7);
  const entityId = useEntityId();
  let t0;
  let t1;
  if ($[0] !== entityId) {
    t0 = ["onboardings", entityId];
    t1 = async t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 0 : t3;
      const response = await getEntitiesByFpIdOnboardings({
        path: {
          fpId: entityId
        },
        query: {
          page: pageParam,
          pageSize: 10
        }
      });
      return response.data;
    };
    $[0] = entityId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = Boolean(entityId);
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      getNextPageParam: _temp,
      initialPageParam: 0,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useInfiniteQuery(t3);
};
export default useGetOnboardings;
function _temp(lastPage) {
  return lastPage.meta.nextPage;
}